import { Route, Routes, useLocation } from "react-router-dom"
import Navbar from "./components/Shared/Navbar"
import Home from "./pages/Home"
import Contact from "./pages/Contact"
import Team from "./pages/Team"
import LocationDetails from "./pages/LocationDetails"
import Build from "./pages/Build"
import Cabins from "./pages/Cabins"
import Invest from "./pages/Invest"
import CabinDetails from "./pages/CabinDetails"
import Footer from "./components/Shared/Footer"
import ScrollToTopButton from "./components/ScrollToTopButton"
import Checkout from "./pages/Checkout"
import TermsAndConditions from "./pages/TermsAndConditions"
import FAQs from "./pages/FAQs"
import Booking from "./pages/Booking"
import Admin from "./pages/Admin"

function App() {
  const location = useLocation()
  const isHomePage = location.pathname === "/"
  const isCheckoutPage = location.pathname === "/checkout"
  const isBookingPage = location.pathname === "/booking"
  const isAdminPage = location.pathname === "/admin"

  return (
    <div>
      {!isHomePage && !isCheckoutPage && !isBookingPage && !isAdminPage && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<Team />} />
        <Route path="/locations/nyc" element={<LocationDetails />} />
        <Route path="/build" element={<Build />} />
        <Route path="/cabins" element={<Cabins />} />
        <Route path="/invest" element={<Invest />} />
        <Route path="/cabins/the-escapist" element={<CabinDetails />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/terms-of-service" element={<TermsAndConditions />} />
        <Route path="/faqs" element={<FAQs />} />
      </Routes>
      {!isHomePage && !isCheckoutPage && !isBookingPage && !isAdminPage && <Footer />}
      {isHomePage && <ScrollToTopButton />}
    </div>
  )
}

export default App
